import { Avatar } from 'antd';
import * as React from 'react';
import en from '../../assets/img/countries/en.svg';
import hu from '../../assets/img/countries/hu.svg';
import ja from '../../assets/img/countries/ja.svg';
import { setLocale } from '../../store/locale/actions';


export default (dispatch: (action: any) => any) => {
    return [
        {
            label: 'English',
            flag: <Avatar size="small" style={{ marginRight: 8 }} src={en}/>,
            setLocale: () => dispatch(setLocale('en')),
        },
        {
            label: 'Magyar',
            flag: <Avatar size="small" style={{ marginRight: 8 }} src={hu}/>,
            setLocale: () => dispatch(setLocale('hu')),
        },
        {
            label: '日本の',
            flag: <Avatar size="small" style={{ marginRight: 8 }} src={ja}/>,
            setLocale: () => dispatch(setLocale('ja')),
        },
    ];
}
